"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const random_1 = __importDefault(require("random"));
const listParse_1 = __importDefault(require("../lib/listParse"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('a', (context, args) => {
    let array = listParse_1.default(args[0]);
    let index = parseInt(args[1]);
    index = isNaN(index) ? random_1.default.int(0, array.length - 1) : index;
    return array[index];
});
